module.exports = __webpack_public_path__ + "static/colouring_in_crew_thumb_2-4ad9c7016b442e119d9246d030173a7f.jpg";